<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Pravice nad predelovalci</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :default-item="defaultItemSezona"
                :value="sezona"
            />
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <Grid  
                       auto-bind=false
                        :sortable="sortable"
                        :filterable="filterable"
                        :groupable="groupable"
                        :pageable="{ buttonCount: 4, pageSizes: true }"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                       
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"
                        @filterchange="filterChange"                
                        @pagechange="pageChangeHandler"
                       
                        :edit-field="'inEdit'"
                        @edit="edit"
                        @save="saveButton"
                        @cancel="cancel"
                        @itemchange="itemChange"
                        
                       
                        >
                 
                    
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                        <button title="Dodaj pravice vstavljati nove zapise v izbrano sezono"
                                class="k-button k-primary"
                                @click='insert'>
                                Dodaj pravice vstavljati nove zapise v izbrano sezono
                        </button>
                         <button title="Odstrani pravice vstavljati nove zapise v izbrano sezono"
                                class="k-button k-primary"
                                @click='remove'>
                                Odstrani pravice vstavljati nove zapise v izbrano sezono
                        </button>
                        
                           
                        </div>
                            
                        </toolbar>
                         
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import '@progress/kendo-ui' // This will import the entire Kendo UI library
// As an alternative, you could import only the scripts that are used by a specific widget:
// import '@progress/kendo-ui/js/kendo.treelist' // Imports only the TreeList script and its dependencies

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
//import { TreeList, TreeListInstaller } from '@progress/kendo-treelist-vue-wrapper'
import kulture from './support/kulture-data';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
//import { sifrantService } from '../services';


//import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
//import numbers from 'cldr-numbers-full/main/es/numbers.json';
//load(
    //likelySubtags,
    //numbers);

import { process } from '@progress/kendo-data-query';



const CommandCell = Vue.component("template-component", {
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String
    },
    computed: {
        //poglej če je group header
        //poglej če obstaja this.dataItem.field in potem this.data.items[0][field]
      returnGroupName(){
        if(this.rowType == 'groupHeader'){
            if(this.dataItem.field&&this.dataItem.items.length==1)
                return {    nivoSifranta:this.dataItem.field,
                            idSifranta:this.dataItem.items[0]['id'+this.dataItem.field],
                            nazivSifranta:this.dataItem.items[0][this.dataItem.field]};
                            //{{returnGroupName}}

                            //plus gumbi za dodajanje kategorij
        }
        else{
            return false;
        }
      },
      renderCell(){
      
        return this.field !== undefined && this.rowType !== 'groupHeader';
      }
    },
    template: ` <td v-if="!dataItem['inEdit']&&renderCell">
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="editHandler">
                        Uredi
                    </button>
                </td>
                <td v-else-if="renderCell||dataItem['inEdit']">
                    
                       <button
                           class="k-button k-grid-save-command"
                           @click="addUpdateHandler">
                           {{dataItem.id? 'Shrani' : 'Dodaj'}}
                       </button>
                       <button
                           class="k-button k-grid-cancel-command"
                           @click="cancelDiscardHandler">
                           {{dataItem.id? 'Prekliči' : 'Prekliči'}}
                       </button>
                   </td>`,
    methods: {
        editHandler: function() {
            this.$emit('edit', {dataItem:this.dataItem});
        },
        addUpdateHandler: function() {
            this.$emit('save', {dataItem:this.dataItem});
        },
        cancelDiscardHandler: function() {
            this.$emit('cancel', {dataItem:this.dataItem});
        }
    }
});



Vue.component('Grid', Grid);
Vue.component('toolbar', GridToolbar);
Vue.component('dropdownlist', DropDownList);


export default {
    data () {
        return {
            defaultItemSezona: { sezona: 'Izberi sezono...'},
            sezona:null,
          
           
            girdDataApi:null,
            gridData:null,


            filter: null,
            editID: null,
            skip: 0,
            take: 5,
            sortable: true,
            filterable: true,
            groupable: false,
            
            expandedItems: [],
            dataResult: [],
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [
                { field: "naziv", title:"Ime",editable:false,width: "250px"},
                { field: "ds", title:"Davčna",editable:false,width: "150px"},
                { field: "mso", title:"MŠO",editable:false,width: "150px"},
                //{ field: "jeaktivna", title:"Aktivna",editable:false,filter:'boolean',width: "100px"},
                { field: "kontrolnaorganizacija", title:"V kontroli pri",editable:false,width: "200px"},
                //{ field: "skupinakulture", title:"Skupina kulture",editable:false,width: "200px"},
                //{ field: "naziv", title:"Kultura",width: "200px"},
                //{ field: "branje", title:"Branje",editor: 'boolean',filter:'boolean',width: "100px" },
                { field: "pisanje", title:"Dovoli pisanje",editor: 'boolean',filter:'boolean',width: "150px", cell:this.pisanjeIcon },
                { cell: CommandCell, width: '180px',filterable:false }
            ]

           

        }
    },
    created () {
     
    },
    computed: {

        ...mapState('pravicePredelava', ['pravicePredelava']),
        ...mapState('users', ['sezonePisanje']),

        
    
           },
      watch: {
        skip(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.pravicePridelava, dataState);
        },
        take(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);
            
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.pravicePridelava, dataState);
        },
       pravicePridelava(newValue, oldValue) {
     // console.log(`Updating from ${oldValue} to ${newValue}`);

      if(newValue){
      // Do whatever makes sense now
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.pravicePridelava, dataState);
        }
    }
},
    methods: {

        ...mapActions('pravicePredelava', ['load','save']),
        
        ...mapMutations('pravicePredelava',['update']),
        pisanjeIcon: function (h, defaultElement , props, listeners ) {
            if(props.dataItem.inEdit)
                return defaultElement;

            let pisanje=h('font-awesome-icon',{props:{icon:"times"}});
            if(props.dataItem.pisanje)
                pisanje=h('font-awesome-icon',{props:{icon:"check"}},{class:{"action_success":true}});
            let pisanjeWrapper=h('span', {class:{
                'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!props.dataItem.pisanje,"action_success":props.dataItem.pisanje}}, [pisanje]);
            return h('td', {attrs:{colspan:1}}, [pisanjeWrapper]);
        },
         filterChange: function(ev) {
            if(ev.event.field=="pisanje"&&ev.filter){
            var curFilter=ev.filter.filters.find(f=>f.field=ev.event.field);
            if(ev.event.value===true) {
                curFilter.operator="gt"
                curFilter.value=0;
            }
            else if(ev.event.value===false) {
                curFilter.operator="eq"
                curFilter.value=0;
            }
        }


            this.filter = ev.filter;
              this.dataResult = process(this.pravicePridelava, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
        },
        sezonaChange(event) {

            if(event.value==this.defaultItemSezona)
                return;
            
            const sezona = event.value;
            this.sezona=sezona;
            this.load({sezona:sezona.sezona});
        },

        
        createAppState: function(dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
                 //  console.log(this.skip);
            this.dataResult = process(this.pravicePridelava, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
           // console.log(this.dataResult);

        },
       
        exportExcel () {
            saveExcel({
                data: this.dataResult,
                fileName: "myFile",
                columns: this.columns
            });
        },
        
        itemChange: function (e) {
            console.log("semo morda tu!!!");
            e.dataItem.pisanjeTmpValue=e.value?1:0;
            //this.update(e.dataItem);
            
            //this.replace(updatedData);
            //this.sifrant = updatedData;
            /*
            this.dataResult = process(this.pravicePridelava, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
            */
        },
         
        edit: function (e) {
              console.log("edit???");
            console.log(e.dataItem);
            Vue.set(e.dataItem, 'inEdit', true);
        },
        insert: function(e) {
            this.save({
                pravicePredelava:{
                    sezona:this.sezona.sezona,predelovalecid:0,kontrolnaorganizacijaid:1,pisanje:1
                    }
                }) ;

             this.save({
                pravicePredelava:{
                    sezona:this.sezona.sezona,predelovalecid:0,kontrolnaorganizacijaid:2,pisanje:1
                    }
                }) ;

              this.save({
                pravicePredelava:{
                    sezona:this.sezona.sezona,predelovalecid:0,kontrolnaorganizacijaid:5,pisanje:1
                    }
                }) ;
              this.save({
                pravicePredelava:{
                    sezona:this.sezona.sezona,predelovalecid:0,kontrolnaorganizacijaid:6,pisanje:1
                    }
                }) ;
        },

        remove: function(e) {
            this.save({
                pravicePredelava:{
                    sezona:this.sezona.sezona,predelovalecid:0,kontrolnaorganizacijaid:1,pisanje:0
                    }
                }) ;

             this.save({
                pravicePredelava:{
                    sezona:this.sezona.sezona,predelovalecid:0,kontrolnaorganizacijaid:2,pisanje:0
                    }
                }) ;

              this.save({
                pravicePredelava:{
                    sezona:this.sezona.sezona,predelovalecid:0,kontrolnaorganizacijaid:5,pisanje:0
                    }
                }) ;
              this.save({
                pravicePredelava:{
                    sezona:this.sezona.sezona,predelovalecid:0,kontrolnaorganizacijaid:6,pisanje:0
                    }
                }) ;
        },

        saveButton: function(e) {
            console.log("save???");
           e.dataItem.pisanje=e.dataItem.pisanjeTmpValue;
            Vue.set(e.dataItem, 'inEdit', undefined);
            this.save({pravicePredelava:e.dataItem}) ;

           this.dataResult = process(this.pravicePridelava, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
        },
        cancel(e) {
           Vue.set(e.dataItem, 'inEdit', undefined);
           
        },
        
         pageChangeHandler: function(event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>

